<!-- @format -->

<template>
  <div class="footer">
    <!-- <Button type="primary">Primary</Button> -->
    <div class="bottom">
      <div class="botcon">
        <img v-if="yishengyice" src="@/assets/ysyc_white.png" alt="" />
        <img v-else  src="@/assets/white.png" alt="" />
        <p class="bottext">
          ©{{yishengyice ? '一生一策' : '毕业申'}} 备案号：<a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备20024996号-{{yishengyice ? 2 : 1}}</a> | 上海：上海人才大厦19楼（静安区梅园路77号） | 北京：清华大学科技园B座清华X-Lab（海淀区中关村东路1号）
        </p>
        <p class="bottext">
          微信：18916565974 | 邮箱：info@applyoffer.com | 联系电话：021-66696957
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    yishengyice: Boolean
  },
  data() {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottom {
  height: 100%;
  width: 100%;
  background: #182b4e;
}

.botcon {
  height: 100%;
  width: 940px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.botcon img {
  margin-top: 30px;
  height: 39px;
}

.bottext {
  margin-top: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.bottext a {
  color: #ffffff;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/public/footer.vue